/**
 * settings.js - Zentrale Konfiguration
 */
import * as THREE from "three";

// Animation & Material Settings
export const settings = {
  size: 0.5,
  metalness: 0.3,
  roughness: 0,
  displacementScale: 0,
  rotation: true,
  breathing: false,
  vertices: true,
  lastRotationUpdateTime: 0,
  breathingStartTime: 0,
  breathingActiveTime: 0,
  lastBreathingUpdateTime: 0,
  rotationSpeed: 0.08,
  verticesIntensity: 0,
  mouseIntensity: true,
  breathingIntensity: 0,

  // Haar-Effekt (Donut)
  hair: true,  // Aktiviert/Deaktiviert die Haare auf dem Donut
  hairGravity: true,  // Haare fallen nach unten (wie bei Mensch/Hund)
  donutVisible: true,  // Donut sichtbar (false = nur Haare)

  // Dissolve-Effekt
  dissolve: true,  // Aktiviert/Deaktiviert den Dissolve-Effekt bei Klick

  // Maus-Verformungseffekt (Wave/Vertices basierend auf Maus Y)
  mouseDeform: true,  // Aktiviert/Deaktiviert den Maus-Verformungseffekt global

  // Partikel-Morphing für Buchstaben
  particleMorph: false,           // Aktiviert Partikel-Morphing zwischen Buchstaben
  particleMorphText: "OPEN121",  // Text der animiert wird (A-Z, 0-9)
  particleMorphShowMesh: true,   // 3D-Buchstaben-Mesh anzeigen (true) oder nur Haare (false)
  particleMorphAutoPlay: false,  // Auto-Wechsel aktiv (Toggle mit Space)
  particleMorphAutoInterval: 3000, // Auto-Wechsel Intervall in ms

  // Partikel-Morph Haar-Settings
  particleMorphHairCount: 20000,         // Anzahl der Haare auf Buchstaben
  particleMorphHairLength: 0.12,         // Länge der Haare auf Buchstaben
  particleMorphHairGravity: true,        // Schwerkraft für Haare
  particleMorphHairGravityStrength: 0.12, // Stärke der Schwerkraft
  particleMorphHairBendStrength: 0.4,    // Biegestärke
  particleMorphHairColorRoot: "#3D2314", // Wurzelfarbe
  particleMorphHairColorTip: "#fff",  // Spitzenfarbe (etwas heller)
  particleMorphMeshColor: "#3D2314",      // Mesh-Farbe
  particleMorphLetterScale: 0.7,         // Buchstaben-Größe (0.1 - 2.0)

  // Word-Display (ganzes Wort nebeneinander)
  wordDisplay: false,                       // Aktiviert Word-Display Modus (TEST)
  wordDisplayText: "OPEN121",              // Anzuzeigendes Wort
  wordDisplayHair: true,                    // Haare an/aus für Word-Display
  wordDisplayHairPerLetter: 8000,          // Haare pro Buchstabe (weniger für Performance)
  wordDisplayHairLength: 0.08,             // Haar-Länge
  wordDisplayHairColorRoot: "#3D2314",     // Wurzelfarbe
  wordDisplayHairColorTip: "#5C3A21",      // Spitzenfarbe
  wordDisplayBendStrength: 0.4,            // Biegestärke
  wordDisplayGravityStrength: 0.12,        // Schwerkraft
  wordDisplayShowMesh: true,               // 3D-Meshes anzeigen
  wordDisplayMeshColor: "#3D2314",         // Mesh-Farbe
  wordDisplayLetterScale: 0.35,            // Buchstaben-Größe (0.1 - 1.0)
  wordDisplayLetterSpacing: 0.35,          // Abstand zwischen Buchstaben (0.1 - 1.0)
  wordDisplayLineHeight: 0.45              // Abstand zwischen Zeilen (für | Zeilenumbruch)
};

// Material-Farbe (persistent) - Weiß für Haut-Look
export const materialColor = new THREE.Color("#3D2314");

// Vertex-Animation Konstanten
export const DAMPING = 0.1;
export const AMOUNT = 8;
export const IMPULSE_DECAY = 0.96;

// Textur-Pfade
export const TEXTURE_PATHS = {
  ObsidianGlass: {
    normalMap: "Textures/Obsidian/N.tga",
    roughnessMap: "Textures/Obsidian/R.tga",
    aoMap: "Textures/Obsidian/AO.tga",
    displacementMap: "Textures/Obsidian/H.tga",
    metalnessMap: "Textures/Obsidian/M.tga",
  },
};
